import React, { Component } from 'react'
import { connect } from 'react-redux'

import { getOrderNotes, SetRead } from '../../../../../actions/notes'

// Styles
import './index.scss'

// Utils
import { renderFullDate } from '../../../../../utils/time'
import { hasAccess } from '../../../../../utils/auth'
import { translation, getOrderNoteShareString } from '../../../../../utils/helpers'

// Elements
import LabelWrapper from '../../../../../shared/elements/labelWrapper'
import Divider from '../../../../../shared/elements/divider'
import Check from '../../../../../shared/elements/check'
import Grid from '../../../../../shared/elements/grid'
import Label from '../../../../../shared/elements/label'

class Notes extends Component {

  constructor (props) {
    super(props)
    this.state = {
      notes: [],
      unread: false
    }
    this.renderNote = this.renderNote.bind(this)
  }

  componentDidMount () {
    this.props.getOrderNotes(this.props.id).then((res) => {
      if (res.data.length !== 0) {
        this.setState({
          notes: res.data
        })
      }
    }, () => {
      console.log('err')
    })
  }

  renderNote (item, key) {
    // console.log(item)
    let isRead = item.IsRead
    let onInputChange = (e) => {
      let checked = e.target.checked
      // Call API and set it to unread
      let data = {
        OrderId: this.props.id,
        OrderNotes: [
          {
            Id: item.NoteID,
            IsRead: checked
          }
        ]
      }

      this.props.SetRead(data).then((res) => {
        // Set notes IsRead to !e.target.checked
        let notes = [...this.state.notes]
        notes[key].IsRead = checked
        this.setState({
          notes: notes,
          unread: true
        })
        this.props.updateOrder(res.data)
      }, () => {
        // Toastr
        window.toastr.error(translation('960'), translation('216'))
      })
    }

    let customerIcon, invoiceIcon
    if (!(hasAccess([4], this.props.auth.user.UserType)) && item.NoteTypeID === 1) {
      customerIcon = <div className='hint--top' aria-label={translation('2321')}><img src='/images/icons/Customer_16.png' /></div>
    }

    if (item.ApplyToInvoice === true) {
      invoiceIcon = <div className='hint--top renderIcons' aria-label={translation('@ Note tilføjet på fakturaen')}><img src='/images/svgs/invoice/Total_price.svg' className='renderIcons' /></div>
    }

    return (
      <LabelWrapper
        key={key}
        labelText={(
          <Grid spacing={0} cols={['max-content', 1, 'min-content']} align='center' fullWidth>
            <span>{renderFullDate(item.NoteDate) + ':'}{customerIcon}{invoiceIcon}</span><span className='user-name'>{item.NoteUserName}</span>
            {item.CanEdditRead && !hasAccess([6], this.props.auth.user.UserType) && <Check simple size='s' id={item.NoteID + '_input'} key={'check_' + key} value='1' onChange={onInputChange} checked={isRead} />}
          </Grid>
        )}>
        {translation(item.SourceDictionaryKey)}: {item.Note}
        {item.ShareType > 0 && (<Label>
          {translation('17861')}
          {getOrderNoteShareString(item.ShareType)}
        </Label>)}
        <Divider />
      </LabelWrapper>
    )
  }

  render () {
    if (this.state.notes.length === 0) {
      return (
        <div className='poppedup padding notesInlinePopup'>
          {translation('2318')}
        </div>
      )
    } else {
      return (
        <div className='poppedup padding notesInlinePopup'>
          {hasAccess([6], this.props.auth.user.UserType) ? <span /> : <Label>{translation('13566')}</Label>}
          <Divider />
          {this.state.notes.map(this.renderNote)}
        </div>
      )
    }

/* if (this.state.unread) {
      return (
        <div className='poppedup padding notesInlinePopup'>
          <span>{translation('2319')}</span>
          {this.state.notes.map(this.renderNote)}
        </div>
      )
    } else {
      return (
        <div className='poppedup padding notesInlinePopup'>
          <span>{translation('2320')}</span>
          {this.state.notes.map(this.renderNote)}
        </div>
      )
    } */
  }
}

function mapStateToProps (state) {
  return {
    auth: state.auth
  }
}

export default connect(mapStateToProps, {
  getOrderNotes,
  SetRead,
  hasAccess
})(Notes)



// WEBPACK FOOTER //
// ./src/app/pages/Orders/OrderList/NewItem/Notes/index.js